<div *ngIf="this.data.type == 'creative-preview'" [ngClass]="{'adjust-height': adType == 'native_video' || bdspNativesWithImg.has(adType)}">
  <h2 class="active text-center">Preview</h2>
  <div *ngIf="!setIframe || adType == 'native_video_content_vast_vpaid_wrapper'"
    class="preview-container mt-1"
  >
    <div
      *ngIf="
        (adType == 'banner' ||
          adType == 'image' ||
          adType == 'display' ||
          bdspNativesWithImg.has(adType) ||
          nativeAdtypes.includes(adType)) &&
        !data.is_coupon_crtv && !tdsp
      "
      [ngClass]="{
        'native-attributes': nativeAdtypes.includes(adType)
      }"
    >
      <div class="mb-2" *ngIf="nativeAdtypes.includes(adType)">
        <img
          *ngIf="previewDetails.native_attributes.icon_url"
          [src]="iconPreview"
          class="native-icon-img me-2"
        />
        <h1
          *ngIf="
            previewDetails.native_attributes.title &&
            previewDetails.native_attributes.title.length > 1
          "
        >
          {{ previewDetails.native_attributes.title }}
        </h1>
      </div>
      <img
        [ngClass]="{'mt-2': nativeAdtypes.includes(adType)}"
        [src]="preview"
        [ngStyle]="{
          height: !nativeAdtypes.includes(adType) && !bdspNativesWithImg.has(adType) ? height + 'px' : '',
          width: !nativeAdtypes.includes(adType) && !bdspNativesWithImg.has(adType) ? width + 'px' : '45vmin',
          'max-height': nativeAdtypes.includes(adType)? '600px': ''
        }"
      />
      <div
        class="native-body"
        *ngIf="
          nativeAdtypes.includes(adType) &&
          previewDetails.native_attributes.description &&
          previewDetails.native_attributes.description.length > 1
        "
      >
        {{ previewDetails.native_attributes.description }}
      </div>
      <div
        class="text-right underline"
        *ngIf="
          nativeAdtypes.includes(adType) &&
          previewDetails.native_attributes.call_to_action
        "
      >
        {{ previewDetails.native_attributes.call_to_action }}
      </div>
      <div
        *ngIf="
          nativeAdtypes.includes(adType) &&
          previewDetails.native_attributes.sponsored_by
        "
      >
        <span
          ><span class="me-1 bold">Sponsored By:</span
          >{{ previewDetails.native_attributes.sponsored_by }}</span
        >
      </div>
    </div>
    <div *ngIf="tdspNativeTypes.has(adType) && tdsp" class="native-attributes">
      <mat-card class="ad-card">
        <div class="banner-container">
          <img
            class="banner-img"
            *ngIf="
              adType == 'native_banner'
                ? true
                : !isPlaying
            "
            [src]="
              adType == 'native_banner'
                ? preview
                : nativeAttributes.image_asset?.s3_file_url
            "
            style="width: 100%; height: 100%"
            alt="Banner"
          />

          <div
            class="play-overlay"
            *ngIf="!isPlaying && adType === 'native_video'"
            (click)="playVideo()"
          >
            <mat-icon>play_circle</mat-icon>
          </div>

          <video
            *ngIf="isPlaying && adType == 'native_video'"
            controls
            style="width: 100%; height: 100%"
            [src]="preview"
          ></video>

          <img
            *ngIf="nativeAttributes.logo_asset?.s3_file_url"
            class="avatar-img"
            [src]="nativeAttributes.logo_asset?.s3_file_url"
            alt="Avatar"
          />
        </div>

        <mat-card-content>
          <img
            *ngIf="nativeAttributes.icon_asset?.s3_file_url"
            class="creative-thumb mt-2"
            [src]="nativeAttributes.icon_asset?.s3_file_url"
            alt="Creative Thumbnail"
          />
          <h3>{{ nativeAttributes.title }}</h3>
          <p class="description">
            {{ nativeAttributes.description }}
          </p>
          <p class="sponsored">
            {{ nativeAttributes.sponsored_by }}
          </p>
        </mat-card-content>

        <mat-card-actions
          *ngIf="nativeAttributes.call_to_action"
          align="end"
        >
          <button mat-stroked-button color="primary">
            {{ nativeAttributes.call_to_action }}
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div
    *ngIf="(adType == 'banner' || adType == 'image') && data.is_coupon_crtv"
    [style.backgroundImage]="'url(' + preview + ')'"
    [ngStyle]="{
      height: height + 'px',
      width: width + 'px'
    }"
    style="
      position: relative;
      background-size: cover;
      background-repeat: no-repeat;
      box-sizing: border-box;
      overflow: hidden;
      padding: 0;"
  >
    <div
      *ngIf="data.details.qr_placement=='banner'"
      [ngStyle]="{
        top: (data?.qr_position?.y_position || 0) + 'px',
        left: (data?.qr_position?.x_position || 0) + 'px',
        width: '75px',
        height: '75px',
        backgroundImage: 'url(./assets/img/qr_code.png)',
        backgroundSize: 'cover',
        position: 'absolute'
      }"
    ></div>
  </div>
    <div *ngIf="(adType == 'banner' || adType == 'dooh_banner') && this.data.tdsp">
      <img
        [ngClass]="{ 'mt-2': nativeAdtypes.includes(adType) }"
        [src]="preview"
        [ngStyle]="{
          height: height + 'px',
          width: width + 'px'
        }"
      />
    </div>
    <ng-container *ngIf="adType == 'native_video' && !tdsp">
      <mat-divider [vertical]=true class="ms-3 full-width"></mat-divider>
      <h2 class="mt-2">Selected Video Creatives-Preview</h2>
    </ng-container>
    <video
      *ngIf="adType == 'video' || adType == 'connected_tv' || adType == 'dooh_video'
      || adType == 'streaming_tv' || adType == 'online_video' ||
      ( adType== 'native_video' && !nativeVideoTagPreview && !tdsp) ||
      adType == 'native_video_content_inline'"
      controls style="height: 40vh; width: 75vh;"
      [src]="adType == 'native_video'? nativeVideoPreviewUrl: adType == 'native_video_content_inline' ? bdspNativeVdeoUrl : preview"></video>
    <audio *ngIf="adType == 'audio'" controls [src]="preview | sanitizerUrl: 'url'"></audio>
    <iframe scrolling="no" *ngIf="adType == 'html5'" [src]="preview"
      [style]="'height: '+ height +'px; width: ' + width + 'px;'"></iframe>
  </div>

  <div *ngIf="setIframe || nativeVideoTagPreview" class="preview-container mt-1">
    <iframe [style]="height && width? 'height: '+ height +'px; width: ' + width + 'px;':''"
      scrolling="no" #tag_iframe *ngIf="adType != 'audio'"></iframe>
    <div *ngIf="adType == 'audio'">
      <!-- <iframe #aud_iframe [src]="preview"></iframe> -->
      <audio *ngIf="adType == 'audio'" controls [src]="preview | sanitizerUrl: 'url'"></audio>
    </div>
  </div>

  <ng-container *ngIf="nativeTypes.has(adType)">
  <app-creative-native-offer-preview
    [stepInput]="{
      adType: adType ,
      nativeOfferDetails: nativeOfferDetails,
      previewNativeImg: preview
    }"
  >
  </app-creative-native-offer-preview>
</ng-container>
</div>

<div class="dialog-content" *ngIf="data.type=='contract_file'">
  <div class="header">
    <img class="alert-vizibl-logo" [src]="imgPath" />
    <div class="close-btn">
      <button class="material-icons close" (click)="closeModel()">close</button>
    </div>
  </div>
  <table style="width: 100%" class="document-table">
    <tr>
      <th class="header-width"><h3>Document Name</h3></th>
      <td><h3>{{data.name}}</h3></td>
    </tr>
    <tr>
      <th class="header-width"><h3>Description</h3></th>
      <td><h3>{{data.description ? data.description : "_"}}</h3></td>
    </tr>
  </table>
  <iframe [src]="data.url | sanitizerUrl: 'resourceUrl'" width="100%" height="85%"></iframe>
  <ng-container *ngIf="data.can_sign">
    <mat-checkbox class="ms-2 mt-2" [(ngModel)]="termsAndConditionsAccepted" (change)="assignId($event)">I have read the terms and conditions.</mat-checkbox>
    <div class="d-flex justify-content-end mb-2 me-2">
      <button mat-button [disabled]="!termsAndConditionsAccepted" (click)="acceptContract()"
        [ngClass]="{'create-btn': true, 'create-btn-disabled':!termsAndConditionsAccepted}">
        Accept
      </button>
    </div>
  </ng-container>
</div>
